import React, { useState } from 'react';

const ACCENT = {
  doctor: '#F15A22',
  staff_nurse: '#0D9488',
  nurse: '#0D9488',
  head_nurse: '#0D9488',
  multi_skill_assistant: '#475569',
  lab_technician: '#4F46E5',
};

/** Circular photo/initials icon for on-duty strip. */
export default function OnDutyAvatar({ person, selected, onClick }) {
  const [failed, setFailed] = useState(false);
  const accent = ACCENT[person.role] || '#071B34';
  const initial = (person.name || '?').replace(/^Dr\.?\s*/i, '')[0]?.toUpperCase() || '?';

  return (
    <button
      type="button"
      onClick={onClick}
      title={person.name}
      className={`group relative flex flex-col items-center gap-1.5 w-[72px] focus:outline-none ${
        selected ? 'scale-105' : 'hover:-translate-y-0.5'
      } transition`}
      data-testid={`on-duty-avatar-${person.staff_id}`}
    >
      <span
        className="h-14 w-14 rounded-full overflow-hidden shadow-sm bg-zinc-100"
        style={{
          boxShadow: selected
            ? `0 0 0 3px ${accent}, 0 0 0 5px rgba(255,255,255,0.9)`
            : `0 0 0 2px ${accent}`,
        }}
      >
        {person.photo_url && !failed ? (
          <img
            src={person.photo_url}
            alt={person.name}
            className="h-full w-full object-cover object-top"
            onError={() => setFailed(true)}
          />
        ) : (
          <span
            className="h-full w-full flex items-center justify-center text-lg font-bold text-white"
            style={{ background: accent }}
          >
            {initial}
          </span>
        )}
      </span>
      <span className="text-[10px] font-semibold text-zinc-800 truncate w-full text-center leading-tight">
        {(person.name || '').replace(/^Dr\.?\s*/i, '').split(' ').slice(-2).join(' ')}
      </span>
      <span className="text-[9px] text-zinc-500 truncate w-full text-center">
        {person.role_label || person.specialisation || 'On duty'}
      </span>
    </button>
  );
}
